import React, { FC } from 'react';
import styled from 'styled-components';

import App from '../../../models/app';
import { clocksPerRow } from '../../../config';
import { ClockRow } from './ClockRow';
import { ClockListContainer } from './Common';

const RowContainer = styled.div`
  padding-bottom: 10px
`;

interface ClockListProps {
  apps: App[];
  collectionId?: string;
}

export const ClockList: FC<ClockListProps> = ({ apps, collectionId }) => {
  const rows = [];
  const numRows = Math.ceil(apps.length / clocksPerRow);
  for (let i = 0; i < numRows; i++) {
    rows.push(
      <RowContainer key={i}>
        <ClockRow index={i} apps={apps} collectionId={collectionId}/>
      </RowContainer>
    );
  }
  return <ClockListContainer>{rows}</ClockListContainer>;
};